import { FontWeight } from "lib/styles";
import { Text } from 'styles/themeColors';

const initialVendorColumns = [
  {
    title: 'Customer Since',
    field: 'customerSince',
    type: 'date',
    dateSetting: { locale: 'en-US' },
    headerStyle: { color: Text.primary, minWidth: '135px !important', fontWeight: FontWeight.bold },
    defaultSort: 'desc'
  },
  {
    title: 'Name',
    field: 'displayName',
    width: '35%',
    headerStyle: { color: Text.primary, minWidth: '135px !important', fontWeight: FontWeight.bold },
  },
  {
    title: 'Status',
    field: 'status',
    removable: false,
    headerStyle: { color: Text.primary, minWidth: '135px !important', fontWeight: FontWeight.bold },
  },
  {
    title: 'ID',
    field: 'vendor.vendorCompanyId',
    width: '20%',
    removable: false,
    headerStyle: { color: Text.primary, minWidth: '135px !important', fontWeight: FontWeight.bold },
  },
  {
    title: 'Country',
    field: 'countryName',
    width: '13%',
    headerStyle: { color: Text.primary, minWidth: '135px !important', fontWeight: FontWeight.bold },
  }
];

export default initialVendorColumns;
